import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/plumbing-leads-colorado")!;

export const Route = createFileRoute("/learn/plumbing-leads-colorado")({
  head: () => seoHead("/learn/plumbing-leads-colorado", "How Colorado Plumbers Get More Calls | Guide", "Guide for Colorado plumbers: emergency searches, frozen-pipe season, service pages, and reviews.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
